module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_affiliateregistration", [["div",{"id":"header"},[["div",{"class":"page-width add-clearfix"},[["div",{"class":"fleft banner"},[["a",{"href":"/","class":"logo"}]]],["ul",{"class":"fleft main nmenu add-clearfix"}],["ul",{"class":"fright second nmenu add-clearfix"}]]]]],["div",{"id":"container"}],["div",{"id":"footer"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/layout/affiliateRegistration.tpl
// module id = 243
// module chunks = 2